import { AMENITIES } from "../data/content";
import { PageIntro } from "../components/PageIntro";
import { Reveal } from "../components/Reveal";
import { VHSImage } from "../components/VHSImage";
import { BookButton } from "../components/Button";

export default function Amenities() {
  return (
    <div data-testid="amenities-page">
      <PageIntro
        label="Amenities"
        titleLines={["Pools, heat,", "and cold", "water."]}
        blurb="Seven spaces. No massage, no facials. The water is the point."
      />

      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        <div className="grid grid-cols-1 gap-px border border-ink bg-ink sm:grid-cols-2 lg:grid-cols-3">
          {AMENITIES.map((a, i) => (
            <Reveal key={a.name} delay={(i % 3) * 0.06} className="bg-cream">
              <article className="group flex h-full flex-col" data-testid={`amenity-${a.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                <VHSImage
                  src={a.image}
                  alt={a.name}
                  className="aspect-[4/3] w-full"
                  border={false}
                  parallax={false}
                />
                <div className="flex flex-1 flex-col p-6 md:p-8">
                  <div className="flex items-baseline justify-between">
                    <h2 className="text-2xl font-medium tracking-tight md:text-3xl">{a.name}</h2>
                    {a.temp && (
                      <span className="text-sm uppercase tracking-[0.15em] text-terracotta">{a.temp}</span>
                    )}
                  </div>
                  <p className="mt-4 text-base font-normal leading-relaxed text-ink/70">{a.line}</p>
                </div>
              </article>
            </Reveal>
          ))}

          {/* CTA tile fills the grid */}
          <div className="flex flex-col items-start justify-center gap-6 bg-terracotta p-8 text-espresso md:p-10">
            <p className="text-3xl font-medium leading-tight tracking-tight md:text-4xl">
              One pass covers all of it.
            </p>
            <BookButton variant="espresso" />
          </div>
        </div>
      </div>
    </div>
  );
}
